var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkNewWindow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 14,
  height: 14,
  x: 0,
  y: 0,
  fill: "#000",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.871 1v.801h2.761l-6.24 6.242.566.566 6.24-6.241v2.761H13V1zM7.134 2.634H1v10.367h10.367v-6.14h-.798v5.343H1.797V3.432h5.337z",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.871 1v.801h2.761l-6.24 6.242.566.566 6.24-6.241v2.761H13V1zM7.134 2.634H1v10.367h10.367v-6.14h-.798v5.343H1.797V3.432h5.337z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.871 1.801h-.25v.25h.25zm0-.801V.75h-.25V1zm2.761.801.177.177.427-.427h-.604zm-6.24 6.242-.178-.177-.176.177.176.177zm.566.566-.177.177.177.177.176-.177zm6.24-6.241h.25v-.604l-.426.427zm0 2.761h-.25v.25h.25zm.802 0v.25h.25v-.25zM13 1h.25V.75H13zM1 2.634v-.25H.75v.25zm6.134 0h.25v-.25h-.25zM1 13.001H.75v.25H1zm10.367 0v.25h.25v-.25zm0-6.14h.25v-.25h-.25zm-.798 0v-.25h-.25v.25zm0 5.343v.25h.25v-.25zm-8.772 0h-.25v.25h.25zm0-8.772v-.25h-.25v.25zm5.337 0v.25h.25v-.25zm1.987-1.63V1h-.5v.801zm2.511-.25h-2.76v.5h2.76zM5.568 8.22l6.241-6.242-.353-.354-6.242 6.242zm.566.213-.566-.567-.354.354.567.566zm5.888-6.242L5.781 8.433l.353.353 6.242-6.241zm.427 2.938V2.368h-.5v2.761zm.551-.25h-.8v.5h.8zM12.75 1v4.129h.5V1zm-3.879.25h4.13v-.5H8.87zM1 2.884h6.134v-.5H1zm.25 10.117V2.634h-.5v10.367zm10.117-.25H1v.5h10.367zm-.25-5.89v6.14h.5v-6.14zm-.548.25h.798v-.5h-.798zm.25 5.093V6.86h-.5v5.343zm-9.022.25h8.772v-.5H1.797zm-.25-9.022v8.772h.5V3.432zm5.587-.25H1.797v.5h5.337zm-.25-.548v.798h.5v-.798z",
  mask: "url(#a)"
})));
export default SvgLinkNewWindow;